module.exports = __webpack_public_path__ + "static/media/34-7.33c03c93.mp3";